<template>
  <div class="info-box-details">
    <div class="info-box-details-caption">Number of users<br />tracking / checked-in</div>
    <div class="info-box-details-table">
      <table class="table table-borderless">
        <tbody>
          <tr repeat.for="trackingUsers of model">
            <td style="text-align: left;">${ trackingUsers.dateRangeName }</td>
            <td style="text-align: center;">${ trackingUsers.trackingUsersCount } / ${ trackingUsers.checkInUsersCount }</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
